// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"711":"25130861","983":"85b3fc76"}[chunkId] + ".css";
};